'use client'
import { axiosAdmin } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";



export function useGetCategoryResults(categoryIds: string, queryParams: Record<string, any> = {}) {
  return useQuery({
    queryKey: ["getcategory", categoryIds, queryParams],
    queryFn: async () => {
      console.log("Category IDs:", categoryIds)
      console.log("Query Params:", queryParams)

      try {
        if (categoryIds) {
          const response = await axiosAdmin.get(`/user/products/filter?categoryId=${categoryIds}`, {
            params: queryParams, // Other filters passed as query params
          })
          console.log("API Response:", response?.data?.data)
          return response?.data
        }
        return null
      } catch (error) {
        console.log("API Error:", error)
        throw error
      }
    },
    enabled: !!categoryIds, // Only run query if categoryIds exist
  })
}

export function useGetCategory(id: any = {}) {
  return useQuery({
    queryKey: ["getcategory", id],
    queryFn: async () => {
      console.log(id)
      try {
        if (id) {
          const response = await axiosAdmin.get(`/user/categories/${id}`)
          console.log(response?.data?.data)
          return response?.data
        }
        return null
      } catch (error) {
        console.log("err", error)
        throw error
      }
    },
  })
}

export function useGetAllCategories() {
  return useQuery({
    queryKey: ['getallcategories'],
    queryFn: async () => {
      try {
        const response = await axiosAdmin.get("/user/categories");
        console.log(response?.data);
        return response?.data;
      } catch (error) {
        console.log('err', error);
        throw error;
      }
    }
  });
}